import { useState } from "react";
import { Navigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Btn, Field, Input } from "../components/kit";
import { Brand } from "../components/Layout";

export default function Login() {
  const { user, login } = useAuth();
  const [f, setF] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try { await login(f.username, f.password); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 halftone opacity-30" />
        <div className="relative text-sm font-bold tracking-[0.25em] text-sky-400">SISTEM PRODUKSI</div>
        <div className="relative">
          <h1 className="text-5xl font-extrabold tracking-tight leading-[1.05]">Sablon cup<br />rapi, tepat<br /><span className="text-sky-400">waktu.</span></h1>
          <p className="mt-6 text-slate-400 max-w-sm">Order, produksi, dan stok dalam satu layar untuk seluruh tim MACCA DESIGN PRINTING.</p>
        </div>
        <div className="relative text-xs text-slate-500">MACCA DESIGN PRINTING</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          <Brand />
          <div>
            <h2 className="text-3xl font-extrabold tracking-tight">Masuk</h2>
            <p className="text-slate-500 text-sm mt-1">Gunakan username dan password dari admin.</p>
          </div>
          <Field label="Username">
            <Input data-testid="login-username-input" autoCapitalize="none" autoComplete="username" value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} required />
          </Field>
          <Field label="Password">
            <Input data-testid="login-password-input" type="password" autoComplete="current-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
          </Field>
          {err && <div data-testid="login-error" className="p-3 rounded-xl bg-rose-50 text-rose-700 text-sm font-semibold border border-rose-200">{err}</div>}
          <Btn data-testid="login-submit-btn" type="submit" loading={busy} className="w-full h-14 text-lg"><LogIn className="w-5 h-5" /> Masuk</Btn>
        </form>
      </div>
    </div>
  );
}
